/* iFitCore PWA install entry for the Shopify mobile menu.
   Adds "APP telepítése" immediately after the Kapcsolat/Contact/Kontakt item
   and uses the browser-native PWA install prompt when available. */
(function () {
  'use strict';

  var deferredPrompt = null;
  var LABELS = {
    hu: { install: 'APP telepítése', installed: 'Az iFitCore már telepítve van.', unavailable: 'A telepítés ezen a böngészőn még nem érhető el. Frissítsd az oldalt, majd próbáld újra.', iosTitle: 'iFitCore telepítése iPhone-ra', ios1: '1. Koppints a Megosztás ikonra.', ios2: '2. Válaszd a „Hozzáadás a Főképernyőhöz” lehetőséget.', ios3: '3. Koppints a „Hozzáadás” gombra.', close: 'Értem' },
    en: { install: 'Install APP', installed: 'iFitCore is already installed.', unavailable: 'Installation is not available in this browser yet. Refresh the page and try again.', iosTitle: 'Install iFitCore on iPhone', ios1: '1. Tap the Share icon.', ios2: '2. Choose “Add to Home Screen”.', ios3: '3. Tap “Add”.', close: 'Got it' },
    de: { install: 'APP installieren', installed: 'iFitCore ist bereits installiert.', unavailable: 'Die Installation ist in diesem Browser noch nicht verfügbar. Lade die Seite neu und versuche es erneut.', iosTitle: 'iFitCore auf dem iPhone installieren', ios1: '1. Tippe auf das Teilen-Symbol.', ios2: '2. Wähle „Zum Home-Bildschirm”.', ios3: '3. Tippe auf „Hinzufügen”.', close: 'Verstanden' }
  };

  function lang() {
    var l = (document.documentElement.lang || 'hu').toLowerCase().slice(0, 2);
    return LABELS[l] ? l : 'hu';
  }
  function standalone() {
    return window.matchMedia && window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  }
  function isIOS() {
    return /iphone|ipad|ipod/i.test(navigator.userAgent || '');
  }
  function showIOSInstallGuide() {
    var old = document.getElementById('ifc-ios-install');
    if (old) old.remove();

    var L = lang();
    var copy = {
      hu: {
        title1: 'iFitCore telepítése',
        title2: 'iPhone-ra',
        intro: 'Az iPhone nem engedi, hogy egy weboldal automatikusan telepítse az appot.',
        s1a: 'Nyomd meg alul a',
        s1b: 'Safari Megosztás ikont',
        s2a: 'Válaszd:',
        s2b: 'Hozzáadás a Főképernyőhöz',
        s3a: 'Nyomd meg:',
        s3b: 'Hozzáadás',
        footer: 'Ezután az iFitCore ikon megjelenik a telefonodon, és appként nyílik meg.',
        close: 'Bezárás'
      },
      en: {
        title1: 'Install iFitCore',
        title2: 'on iPhone',
        intro: 'iPhone does not allow a website to install the app automatically.',
        s1a: 'Tap the',
        s1b: 'Safari Share icon',
        s2a: 'Choose:',
        s2b: 'Add to Home Screen',
        s3a: 'Tap:',
        s3b: 'Add',
        footer: 'The iFitCore icon will then appear on your phone and open like an app.',
        close: 'Close'
      },
      de: {
        title1: 'iFitCore installieren',
        title2: 'auf dem iPhone',
        intro: 'Das iPhone erlaubt Webseiten keine automatische App-Installation.',
        s1a: 'Tippe unten auf das',
        s1b: 'Safari Teilen-Symbol',
        s2a: 'Wähle:',
        s2b: 'Zum Home-Bildschirm',
        s3a: 'Tippe auf:',
        s3b: 'Hinzufügen',
        footer: 'Danach erscheint das iFitCore-Icon auf deinem iPhone und öffnet sich wie eine App.',
        close: 'Schließen'
      }
    }[L];

    var style=document.getElementById('ifc-ios-install-style');
    if(!style){
      style=document.createElement('style');
      style.id='ifc-ios-install-style';
      style.textContent=
        '#ifc-ios-install{position:fixed;inset:0;z-index:2147483647;background:rgba(0,0,0,.78);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);display:flex;align-items:center;justify-content:center;padding:14px calc(14px + env(safe-area-inset-right)) calc(14px + env(safe-area-inset-bottom)) calc(14px + env(safe-area-inset-left));font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif}' +
        '#ifc-ios-install *{box-sizing:border-box}' +
        '#ifc-ios-install .ifc-card{width:min(430px,100%);max-height:94vh;overflow:auto;background:linear-gradient(180deg,#171717 0%,#0b0b0b 100%);border:1px solid rgba(208,168,69,.72);border-radius:26px;padding:20px 18px 16px;color:#f4f4f4;box-shadow:0 30px 90px rgba(0,0,0,.72);position:relative}' +
        '#ifc-ios-install .ifc-x{position:absolute;right:10px;top:10px;width:40px;height:40px;border:0;background:transparent;color:#8e8e8e;font-size:30px;line-height:1;cursor:pointer}' +
        '#ifc-ios-install .ifc-brand{display:flex;align-items:center;gap:12px;padding-right:42px}' +
        '#ifc-ios-install .ifc-brand img{width:58px;height:58px;border-radius:15px;border:1px solid rgba(208,168,69,.45);box-shadow:0 8px 22px rgba(0,0,0,.35)}' +
        '#ifc-ios-install .ifc-title{font-size:28px;line-height:1.04;font-weight:850;letter-spacing:-.35px;color:#fff}' +
        '#ifc-ios-install .ifc-title span{display:block;color:#d8b255}' +
        '#ifc-ios-install .ifc-intro{margin:18px 2px 8px;color:#b8b8b8;font-size:15px;line-height:1.45}' +
        '#ifc-ios-install .ifc-steps{margin-top:10px;border-top:1px solid rgba(255,255,255,.08)}' +
        '#ifc-ios-install .ifc-step{display:grid;grid-template-columns:48px minmax(0,1fr) 118px;gap:12px;align-items:center;padding:16px 0;border-bottom:1px solid rgba(255,255,255,.08)}' +
        '#ifc-ios-install .ifc-num{width:40px;height:40px;border-radius:50%;border:2px solid #d8b255;display:grid;place-items:center;color:#e2bd62;font-weight:900;font-size:18px}' +
        '#ifc-ios-install .ifc-copy{min-width:0;font-size:15px;line-height:1.35;color:#f0f0f0}' +
        '#ifc-ios-install .ifc-copy strong{display:block;font-size:16px;font-weight:800;color:#fff;margin-top:2px}' +
        '#ifc-ios-install .ifc-visual{min-height:76px;border-radius:15px;background:#202020;border:1px solid rgba(255,255,255,.08);display:flex;align-items:center;justify-content:center;padding:10px;position:relative;overflow:hidden;color:#d7d7d7}' +
        '#ifc-ios-install .ifc-safari-mini{width:100%;height:58px;border-radius:13px;background:#f3f3f3;display:flex;align-items:center;justify-content:space-around;color:#8b8b8b;padding:0 8px}' +
        '#ifc-ios-install .ifc-share-icon{width:38px;height:38px;border-radius:11px;border:2px solid #d8b255;display:grid;place-items:center;color:#0a67d8;background:#fff}' +
        '#ifc-ios-install .ifc-home-row{width:100%;height:54px;border-radius:12px;background:#2a2a2a;display:flex;align-items:center;gap:10px;padding:0 12px;font-size:12px;color:#f1f1f1}' +
        '#ifc-ios-install .ifc-plus{width:28px;height:28px;border-radius:7px;border:2px solid #f1f1f1;display:grid;place-items:center;font-size:22px;line-height:1}' +
        '#ifc-ios-install .ifc-add-screen{width:100%;border-radius:12px;background:#232323;padding:9px 10px}' +
        '#ifc-ios-install .ifc-add-top{display:flex;justify-content:space-between;font-size:11px;color:#a6a6a6;margin-bottom:9px}' +
        '#ifc-ios-install .ifc-add-top strong{color:#72a9ff;font-size:12px}' +
        '#ifc-ios-install .ifc-app-line{display:flex;align-items:center;gap:8px}' +
        '#ifc-ios-install .ifc-app-line img{width:32px;height:32px;border-radius:8px}' +
        '#ifc-ios-install .ifc-app-line div{font-size:11px;color:#eee;line-height:1.2}' +
        '#ifc-ios-install .ifc-footer{display:grid;grid-template-columns:54px 1fr;gap:12px;align-items:center;padding:16px 4px 6px}' +
        '#ifc-ios-install .ifc-phone-icon{width:44px;height:62px;border-radius:10px;border:2px solid #d8b255;display:flex;align-items:center;justify-content:center}' +
        '#ifc-ios-install .ifc-phone-icon img{width:28px;height:28px;border-radius:7px}' +
        '#ifc-ios-install .ifc-footer-text{color:#c8c8c8;font-size:13px;line-height:1.45}' +
        '#ifc-ios-install .ifc-close-text{display:block;margin:8px auto 0;padding:6px 2px;border:0;border-bottom:1px solid #777;background:transparent;color:#8f8f8f;font-size:13px;cursor:pointer}' +
        '@media(max-width:380px){#ifc-ios-install .ifc-card{padding:18px 14px 14px}#ifc-ios-install .ifc-title{font-size:24px}#ifc-ios-install .ifc-step{grid-template-columns:42px minmax(0,1fr) 102px;gap:8px}#ifc-ios-install .ifc-visual{padding:7px}}';
      document.head.appendChild(style);
    }

    var wrap=document.createElement('div');
    wrap.id='ifc-ios-install';
    wrap.setAttribute('role','dialog');
    wrap.setAttribute('aria-modal','true');

    var card=document.createElement('div');
    card.className='ifc-card';

    var close=document.createElement('button');
    close.type='button';
    close.className='ifc-x';
    close.setAttribute('aria-label',copy.close);
    close.textContent='×';
    close.onclick=function(){wrap.remove();};

    var brand=document.createElement('div');
    brand.className='ifc-brand';
    brand.innerHTML=
      '<img src="https://cdn.shopify.com/s/files/1/0955/3615/2959/files/ifitcore-pwa-192.png?v=1791577480" alt="">' +
      '<div class="ifc-title">'+copy.title1+'<span>'+copy.title2+'</span></div>';

    var intro=document.createElement('div');
    intro.className='ifc-intro';
    intro.textContent=copy.intro;

    var steps=document.createElement('div');
    steps.className='ifc-steps';

    var shareSvg='<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 15V3"/><path d="m7.5 7.5 4.5-4.5 4.5 4.5"/><path d="M6 10H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-1"/></svg>';

    function step(num,htmlCopy,visualHtml){
      var row=document.createElement('div');
      row.className='ifc-step';
      row.innerHTML=
        '<div class="ifc-num">'+num+'</div>' +
        '<div class="ifc-copy">'+htmlCopy+'</div>' +
        '<div class="ifc-visual" aria-hidden="true">'+visualHtml+'</div>';
      return row;
    }

    steps.appendChild(step(
      1,
      copy.s1a+'<strong>'+copy.s1b+'</strong>',
      '<div class="ifc-safari-mini"><span>‹</span><span>›</span><div class="ifc-share-icon">'+shareSvg+'</div><span>▢</span></div>'
    ));

    steps.appendChild(step(
      2,
      copy.s2a+'<strong>'+copy.s2b+'</strong>',
      '<div class="ifc-home-row"><div class="ifc-plus">+</div><div>'+copy.s2b+'</div></div>'
    ));

    steps.appendChild(step(
      3,
      copy.s3a+'<strong>'+copy.s3b+'</strong>',
      '<div class="ifc-add-screen"><div class="ifc-add-top"><span>×</span><strong>'+copy.s3b+'</strong></div><div class="ifc-app-line"><img src="https://cdn.shopify.com/s/files/1/0955/3615/2959/files/ifitcore-pwa-192.png?v=1791577480" alt=""><div><strong style="display:block;color:#fff;font-size:11px">iFitCore</strong><span style="color:#8f8f8f">ifitcore.hu</span></div></div></div>'
    ));

    var footer=document.createElement('div');
    footer.className='ifc-footer';
    footer.innerHTML=
      '<div class="ifc-phone-icon"><img src="https://cdn.shopify.com/s/files/1/0955/3615/2959/files/ifitcore-pwa-192.png?v=1791577480" alt=""></div>' +
      '<div class="ifc-footer-text">'+copy.footer+'</div>';

    var closeText=document.createElement('button');
    closeText.type='button';
    closeText.className='ifc-close-text';
    closeText.textContent=copy.close;
    closeText.onclick=function(){wrap.remove();};

    card.appendChild(close);
    card.appendChild(brand);
    card.appendChild(intro);
    card.appendChild(steps);
    card.appendChild(footer);
    card.appendChild(closeText);
    wrap.appendChild(card);

    wrap.addEventListener('click',function(e){if(e.target===wrap)wrap.remove();});
    document.body.appendChild(wrap);
  }

  function contactText(s) {
    s = String(s || '').replace(/\s+/g, ' ').trim().toLowerCase();
    return s === 'kapcsolat' || s === 'contact' || s === 'kontakt' ||
      s.indexOf('kapcsolat ') === 0 || s.indexOf('contact ') === 0 || s.indexOf('kontakt ') === 0;
  }

  function findContactElement() {
    var selectors = [
      'menu-drawer a', 'menu-drawer button', 'menu-drawer summary',
      '.menu-drawer a', '.menu-drawer button', '.menu-drawer summary',
      '[class*="drawer"] a', '[class*="drawer"] button', '[class*="drawer"] summary',
      'nav a', 'nav button', 'nav summary'
    ].join(',');
    var els = Array.prototype.slice.call(document.querySelectorAll(selectors));
    var exact = els.filter(function (el) { return contactText(el.textContent); });
    if (exact.length) return exact[exact.length - 1];

    // Horizon themes may wrap the visible label several levels below the clickable row.
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_ELEMENT);
    var node, fallback = null;
    while ((node = walker.nextNode())) {
      if (!contactText(node.textContent)) continue;
      var click = node.closest && node.closest('a,button,summary,[role="link"],[role="button"]');
      if (click) fallback = click;
    }
    return fallback;
  }

  async function install() {
    var T = LABELS[lang()];
    if (standalone()) { window.alert(T.installed); return; }

    if (isIOS()) {
      showIOSInstallGuide();
      return;
    }

    if (deferredPrompt) {
      var p = deferredPrompt;
      deferredPrompt = null;
      await p.prompt();
      try { await p.userChoice; } catch (e) {}
      return;
    }
    window.alert(T.unavailable);
  }

  function buildFrom(anchor) {
    var label = LABELS[lang()].install;
    var a = anchor.cloneNode(true);
    a.removeAttribute('href');
    a.setAttribute('href', '#');
    a.setAttribute('data-ifc-pwa-install', '1');
    a.setAttribute('role', 'button');
    a.setAttribute('aria-label', label);

    // Replace visible text without destroying theme icons/chevrons.
    var textNodes = [];
    (function walk(n) {
      Array.prototype.forEach.call(n.childNodes || [], function (x) {
        if (x.nodeType === 3 && x.nodeValue.trim()) textNodes.push(x);
        else if (x.nodeType === 1) walk(x);
      });
    })(a);
    if (textNodes.length) {
      textNodes[0].nodeValue = label;
      for (var i = 1; i < textNodes.length; i++) textNodes[i].nodeValue = '';
    } else {
      a.textContent = label;
    }

    a.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      install();
    });

    var row = anchor.closest('li');
    if (row && row.parentNode) {
      var clone = row.cloneNode(false);
      clone.setAttribute('data-ifc-pwa-row', '1');
      clone.appendChild(a);
      row.parentNode.insertBefore(clone, row.nextSibling);
      return true;
    }
    anchor.parentNode.insertBefore(a, anchor.nextSibling);
    return true;
  }

  function isDrawerLink(a) {
    return !!a.closest('menu-drawer, header-drawer, .menu-drawer, [data-mobile-menu], [class*="drawer"]');
  }

  function wireConfiguredMenuItem() {
    var links = Array.prototype.slice.call(document.querySelectorAll('a[href*="#ifitcore-install-app"]'));
    if (!links.length) return false;

    links.forEach(function (a) {
      if (a.__ifcPwaWired) return;
      a.__ifcPwaWired = true;

      var row = a.closest('li');

      /* The same Shopify menu can also render in the desktop header.
         Keep the install item only in the mobile/tablet drawer. */
      if (!isDrawerLink(a)) {
        (row || a).style.display = 'none';
        return;
      }

      a.setAttribute('data-ifc-pwa-install', '1');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        install();
      });
    });
    return true;
  }

  function inject() {
    /* Preferred: a real Shopify Navigation item. This guarantees exact placement
       after Contact and lets the merchant manage its label/order normally. */
    if (wireConfiguredMenuItem()) return;

    /* Fallback for themes where no navigation item has been configured yet. */
    if (document.querySelector('[data-ifc-pwa-install="1"]')) return;
    var contact = findContactElement();
    if (!contact) return;
    buildFrom(contact);
  }

  window.addEventListener('beforeinstallprompt', function (e) {
    e.preventDefault();
    deferredPrompt = e;
    inject();
  });
  window.addEventListener('appinstalled', function () {
    deferredPrompt = null;
    document.querySelectorAll('[data-ifc-pwa-row]').forEach(function (el) { el.remove(); });
    document.querySelectorAll('[data-ifc-pwa-install]').forEach(function (el) {
      var row = el.closest('li');
      (row || el).style.display = 'none';
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject);
  else inject();

  new MutationObserver(function () { inject(); }).observe(document.documentElement, { childList: true, subtree: true });
})();